import { gql } from "@apollo/client";

export const SERVICE_ACCOUNT_ASSET_COUNT = gql`
  query ServiceAccountAssetCount(
    $scopeMrn: String!
    $queryTerms: [String!]
    $first: Int
  ) {
    assets(scopeMrn: $scopeMrn, queryTerms: $queryTerms, first: $first) {
      totalCount
    }
  }
`;
